import * as React from 'react';
import { useEffect } from 'react';
import { Typography, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { getAllLeadWorkHistory, getAllLeadWorkHistoryByIdThunk } from '../../../Slices/salesSlice';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { setLoader } from '../../../Slices/loaderSlice';
import LeadActivityTimeline from './LeadActivityTimeline';


export default function SalesWorkHistory(props) {

  const { SalesInfo } = props;
  const dispatch = useDispatch()
  const leadWorkHistoryDetails = useSelector((state) => state.sales.salesWorkHistory)
  const leadWorkHistory = useSelector((state) => state.sales.workHistory);

  const workHistoryObj = {
    leadId: SalesInfo?.id,
  }
  
  useEffect(() => {
    dispatch(getAllLeadWorkHistoryByIdThunk(workHistoryObj));
  }, [SalesInfo.id]);

  useEffect(() => {
    if(SalesInfo?.id) {
    dispatch(getAllLeadWorkHistory(SalesInfo?.id));
    }
  }, [SalesInfo.id]);

  const getDateTime = (timeValue) => {
    if (!timeValue) return '';
    const startDate = new Date(timeValue).toLocaleDateString();
    const startTimeString = new Date(timeValue).toLocaleTimeString(undefined, { hour12: true });
    return `${startDate} ${startTimeString}`;
  };

  const getTotalWorkingHours = (workHistoryDetails) => {
    let diff = 0;
    workHistoryDetails.forEach((row) => {
      diff += parseInt(row?.endTime) - parseInt(row?.startTime);
    });
    return getTimeToString(diff);
  };

  const calculateWorkingHours = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    return getTimeToString(end - start);
  };

  const assignToUsers = useSelector((state) => state.loginUserInfo.allUsers);

  const getUserName = (userid) => {
    let userName = 'anonymous';
    assignToUsers?.forEach((userdetails) => {
      if (userdetails?.id === userid) {
        userName = userdetails?.firstname + ' ' + userdetails?.lastname;
      }
    });
    return userName;
  };
  const getTimeToString = (diff) => {
    const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
    const days = Math.floor((diff / (1000 * 60 * 60 * 24)) % 30);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    return [
      months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '',
      days > 0 ? `${days} day${days > 1 ? 's' : ''}` : '',
      hours > 0 ? `${hours} hr${hours > 1 ? 's' : ''}` : '',
      minutes > 0 ? `${minutes} min${minutes > 1 ? 's' : ''}` : '',
      seconds > 0 ? `${seconds} sec${seconds > 1 ? 's' : ''}` : '',
    ].filter(Boolean).join(' ');
  };

  const workHistoryColumns = [
    {
      title: 'Total Time',
      dataIndex: 'totalTime',
      width: 110,
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Start',
      dataIndex: 'startTime',
      width: 150,
      ellipsis: { showTitle: false },
      render: (text) => <Tooltip title={text}><span>{text}</span></Tooltip>,
    },
    {
      title: 'End',
      dataIndex: 'endTime',
      width: 150,
      ellipsis: { showTitle: false },
      render: (text) => <Tooltip title={text}><span>{text}</span></Tooltip>,
    },
    {
      title: 'Task',
      dataIndex: 'taskDescription',
      width: 140,
      ellipsis: { showTitle: false },
      render: (text) => <Tooltip title={text}><span>{text || '—'}</span></Tooltip>,
    },
    {
      title: 'User',
      dataIndex: 'userName',
      ellipsis: { showTitle: false },
      render: (text) => <Tooltip title={text}><span>{text}</span></Tooltip>,
    },
  ];

  const workHistoryData = (leadWorkHistory || [])?.map((row) => ({
    key: row?.id || `${row?.userId}-${row?.startTime}-${row?.endTime}`,
    id: row.id,
    totalTime: calculateWorkingHours(parseInt(row?.startTime), parseInt(row?.endTime)),
    startTime: getDateTime(parseInt(row?.startTime)),
    endTime: getDateTime(parseInt(row?.endTime)),
    taskDescription: row?.taskType,
    userName: getUserName(row?.userId),
  }));

  const handleSync = async () => {
    dispatch(setLoader(true));
    try {
      await dispatch(getAllLeadWorkHistory(SalesInfo?.id))
    } catch (error) {
      console.error('Error refetching work history:', error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  return (
    <div className="sales-work-history-card sales-work-history-card--timeline">

      <Typography.Title level={5} className="sales-work-history-title">
        Activity Timeline
      </Typography.Title>

      {/* TIMELINE — who changed what, from what to what, and when */}
      <LeadActivityTimeline
        history={leadWorkHistoryDetails}
        createdDate={SalesInfo?.createdDate}
        createdBy={SalesInfo?.createdBy}
      />

      <Typography.Title level={5} className="sales-time-records-title">
        Sales Time Records ({getTotalWorkingHours(leadWorkHistory)})
        <Tooltip title="Sync Now">
          <FontAwesomeIcon
            icon={faSync}
            className="sync-icon"
            onClick={handleSync}
          />
        </Tooltip>
      </Typography.Title>

      {/* SECOND SCROLL GRID */}
      <div className="sales-timerecords-scroll">
        {workHistoryData.length === 0 ? (
          <div style={{ color: '#9ca3af', fontSize: 12, padding: 8 }}>No time records yet.</div>
        ) : (
          <CustomGridTable
            Id="sales-time-records-table"
            columns={workHistoryColumns}
            dataSource={workHistoryData}
            rowKey="key"
            pagination={false}
            bordered
            size="small"
          />
        )}
      </div>

    </div>
  );
}